export default __webpack_public_path__ + "static/media/icon_partner-silver.b1d5dffc.svg";